


const BackDrop = ({ dropPress }) => {
    return ( 
        <div className="backdrop" onClick={dropPress}></div>
    );
}
 
export default BackDrop;